import { get, post } from '../helpers/api.helper';
import config from '../config/config';
import { parseServiceResponse } from '@/helpers/serviceParsing';
import { SpaceHomeStateType } from '@/store/spaceHomeStore';
import { useAnonymousUserStore, useUserStore } from '@/store/userStore';

const { chat_api, studio_api, proxy2_api } = config.api;
export const getSpaceHome = async (userId: string) => {
    try {
        const response = await get(`${chat_api}/talk2you/users/profile/${userId}/spacehome`);
        return parseServiceResponse<SpaceHomeStateType>(response);
    } catch (error) {
        throw parseServiceResponse(error);
    }
};
export const getProfileWithPath = async (path: string) => {
    try {
        const response = await get(`${chat_api}/talk2you/users/profile/landing-page/${path}`);
        return parseServiceResponse<GetProfileWithPathResponseType>(response);
    } catch (error) {
        throw parseServiceResponse(error);
    }
};

// renewal api

export async function getSpaceProfileByPath(path: string) {
    try {
        const response = await get(`${studio_api}/users/profile/by-path/${path}`).then(r => r)
        return parseServiceResponse<GetProfileWithPathResponseType>(response)
    } catch (error) {
        throw parseServiceResponse(error);
    }
}
export async function getSpaceProfileByUserId(userId: string) {
    try {
        const response = await get(`${studio_api}/users/profile/by-userId/${userId}`).then(r => r)
        return parseServiceResponse(response)
    } catch (error) { throw error }
}

export async function getSpaceHomeData(userId: string) {
    try {
        const response = await get(`${studio_api}/spacehome/${userId}/spacehome-data`).then(r => r)
        return parseServiceResponse(response);
    } catch (error) {
        throw parseServiceResponse(error);
    }
}
export async function getSpaceHomeBlockData(userId: string) {
    try {
        const response = await get(`${studio_api}/spacehome/${userId}/block-data`).then(r => r)
        return response;
    } catch (error) {
        throw parseServiceResponse(error);
    }
}
export async function getSpaceHomeSpeedBlockData(userId: string) {
    try {
        const response = await get(`${studio_api}/spacehome/${userId}/block-data/info`).then(r => r)
        return response;
    } catch (error) {
        throw parseServiceResponse(error);
    }
}
export async function getSpaceHomeBlockDetailData(userId: string, blockId: string) {
    try {
        const response = await get(`${studio_api}/spacehome/${userId}/block-data/${blockId}`).then(r => r.data.item)
        return response;
    } catch (error) {
        throw parseServiceResponse(error);
    }
}

export async function postBusinessOffer(body: any) {
    try {
        return await post(`${studio_api}/spacehome/suggest/business`, { ...body }).then(r => r)
    } catch (err) {
        throw parseServiceResponse(err)
    }
}

export async function getBusinessCategoryList() {
    try {
        return await get(`${studio_api}/spacehome/matching/category`).then(r => r)
    } catch (err) { throw parseServiceResponse(err) }
}


export const studioYoutubeCrawler = async (url: string) => {
    try {
        return await get(`${studio_api}/spacehome/youtube/crawling?videoUrl=${url}`).then(r => r.data)
        // return await get(`/youtube/video-info?url=${url}`, { baseURL: proxy2_api }).then(r => r)
    } catch (err) { throw err }
}

export const studioTikTokCrawler = async (url: string) => {
    try {
        return await get(`https://www.tiktok.com/oembed?url=${url}`,).then(r => r.data)
    } catch (err) { throw err }
}

type GetProfileWithPathResponseType = {
    user_id: string;
    type: string;
    path: string;
};

// spacehome V2

export const getSpaceHomeDesignDataV2 = async (userId: string) => {
    try {
        return await get(`${studio_api}/v2/spacehome/${userId}/design`).then(r => r.data) || { item: {} }
    } catch (error) { throw error }
}
export const getEventBlockListV2 = async (userId: string) => {
    try {
        return await get(`${studio_api}/v2/spacehome/${userId}/event-blocks`).then(r => r.data?.item_list || [])
    } catch (error) { throw error }
}